import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import marketPlaceApis from "../../apiConfigs/marketplace";
import { ReactComponent as Delete } from "../../assets/delete.svg";
import { ReactComponent as Edit } from "../../assets/edit.svg";
import DeleteModal from "../../designComponents/DeleteModal";
import LabelInputField from "../../designComponents/LabelInputField/LabelInputField";
import MediaUploader from "../../designComponents/MediaUpload/MediaUpload";
import Modal from "../../designComponents/Modal";
import requestAPI from "../../utils/requestAPI";
import { getIconsUrl } from "../../utils/resizeImages";
import { uploadFilesToS3OnlyKeys } from "../../utils/s3Upload";
import {
  AcceptButton,
  ButtonsSection,
  Card,
  LabelText,
  SectionTitle,
  TitleSection,
} from "../Properties/Details/styles";

type MODAL_STATE_TYPE = {
  categoryId?: string;
  state: "add" | "edit" | "delete" | undefined;
};

const INITIAL_MODAL_STATE: MODAL_STATE_TYPE = {
  categoryId: undefined,
  state: undefined,
};

const ProductCategories = () => {
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [productCategories, setProductCategories] = useState<
    { name: string; _id: string; icon: string }[]
  >([]);
  const [name, setName] = useState("");
  const [initialValues, setInitialValues] = useState<{
    name?: string;
    icon?: string | File;
  }>({ name: undefined, icon: undefined });

  const [modalState, setModalState] =
    useState<MODAL_STATE_TYPE>(INITIAL_MODAL_STATE);

  const getProductCategories = async () => {
    const response = await requestAPI(
      marketPlaceApis.getAllProductCategories()
    );
    setProductCategories(response);
  };

  useEffect(() => {
    getProductCategories();
  }, []);

  const handleDeleteProductCategory = async (id: string) => {
    try {
      await requestAPI(marketPlaceApis.deleteProductCategory(id));
      toast.success("Successfully Deleted");
      await getProductCategories();
      setModalState(INITIAL_MODAL_STATE);
    } catch (error: any) {
      toast.error("Error " + error.message);
    }
  };

  const handleAddProductCategory = async () => {
    let providedUrl;
    try {
      if (uploadedFile && typeof uploadedFile !== "string") {
        const uploadFiles = await uploadFilesToS3OnlyKeys({
          category: "assets",
          fileUri: [uploadedFile],
          assetsCategory: "Product Categories",
        });
        if (uploadFiles && uploadFiles.length > 0) {
          providedUrl = uploadFiles[0];
          await requestAPI(
            marketPlaceApis.addProductCategory({ icon: providedUrl, name })
          );
        }
      } else if (typeof uploadedFile === "string") {
        providedUrl = uploadedFile;
        await requestAPI(
          await requestAPI(
            marketPlaceApis.addProductCategory({ icon: providedUrl, name })
          )
        );
      }
      setUploadedFile(null);
      toast.success("Successfully Added Product Category");
      await getProductCategories();
      setModalState(INITIAL_MODAL_STATE);
    } catch (error: any) {
      toast.error("Error:" + error.message);
    }
  };
  const handleEditProductCategory = async (id: string) => {
    let providedUrl;
    try {
      if (uploadedFile && typeof uploadedFile !== "string") {
        const uploadFiles = await uploadFilesToS3OnlyKeys({
          category: "assets",
          fileUri: [uploadedFile],
          assetsCategory: "Product Categories",
        });
        if (uploadFiles && uploadFiles.length > 0) {
          providedUrl = uploadFiles[0];
          await requestAPI(
            marketPlaceApis.updateProductCategory(id, {
              name: initialValues.name ?? "",
              icon: providedUrl,
            })
          );
        }
      } else if (typeof uploadedFile === "string") {
        providedUrl = uploadedFile;
        await requestAPI(
          marketPlaceApis.updateProductCategory(id, {
            name: initialValues.name ?? "",
            icon: providedUrl,
          })
        );
      } else if (!uploadedFile) {
        await requestAPI(
          marketPlaceApis.updateProductCategory(id, {
            name: initialValues.name ?? "",
            icon:
              typeof initialValues.icon === "string" ? initialValues?.icon : "",
          })
        );
      }
      setModalState(INITIAL_MODAL_STATE);
      getProductCategories();
      toast.success("Successfully Updated Product Category");
    } catch (error: any) {
      toast.error("Error:" + error.message);
    }
  };
  return (
    <div>
      <Card style={{ margin: 0 }}>
        <TitleSection>
          <ButtonsSection>
            <SectionTitle>Product Categories</SectionTitle>
            <AcceptButton
              onClick={() => {
                setModalState({ state: "add" });
              }}
            >
              Add Category
            </AcceptButton>
          </ButtonsSection>
        </TitleSection>
        {productCategories.map((pCat, index) => {
          return (
            <ButtonsSection key={index}>
              <div
                style={{
                  display: "flex",
                  gap: 40,
                  alignItems: "center",
                }}
              >
                <img
                  src={getIconsUrl(pCat.icon)}
                  width={40}
                  height={40}
                  style={{ borderRadius: 40 }}
                  alt={pCat?.name}
                ></img>
                <LabelText>{pCat.name}</LabelText>
              </div>
              <div style={{ display: "flex", gap: 20, cursor: "pointer" }}>
                <div
                  onClick={() => {
                    setModalState({ state: "delete", categoryId: pCat?._id });
                  }}
                >
                  <Delete fill="#7E7E7E"></Delete>
                </div>
                <div
                  onClick={() => {
                    setModalState({ state: "edit", categoryId: pCat?._id });
                    setInitialValues({
                      name: pCat.name,
                      icon: pCat.icon,
                    });
                  }}
                >
                  <Edit fill="#7E7E7E" />
                </div>
              </div>

              <DeleteModal
                loading={false}
                onClose={() => {
                  setModalState(INITIAL_MODAL_STATE);
                }}
                itemName="Category"
                title="Are you sure you want to delete this Category"
                isOpen={modalState?.state === "delete"}
                onDelete={async () => {
                  await handleDeleteProductCategory(pCat._id);
                }}
              />

              <Modal
                halfWidth
                isOpen={modalState?.state === "edit"}
                title="Edit Trades Category"
                onClose={() => {
                  setModalState(INITIAL_MODAL_STATE);
                }}
              >
                <LabelInputField
                  label="Name"
                  value={initialValues.name}
                  onChange={(e) => {
                    setName(e.target.value);
                    setInitialValues((prev) => ({
                      ...prev,
                      name: e.target.value,
                    }));
                  }}
                  name="Product Category Name"
                  style={{
                    label: {
                      fontSize: "14px",
                      fontWeight: "500px",
                      color: "#555A77",
                    },
                    input: {
                      height: 50,
                      border: "1px solid #F1EFFB",
                      padding: 8,
                      background: "#F1EFFB",
                      borderRadius: 6,
                      width: "100%",
                    },
                    container: {
                      display: "flex",
                      flexDirection: "column",
                      gap: 6,
                      paddingTop: 14,
                    },
                  }}
                ></LabelInputField>
                <MediaUploader
                  label="Icon"
                  image={
                    initialValues.icon && typeof initialValues.icon === "string"
                      ? [initialValues.icon]
                      : []
                  }
                  onChange={(e) => {
                    const file = e.target.files?.[0] || null;
                    setInitialValues((prev) => ({ ...prev, icon: file ?? "" }));
                  }}
                  style={{
                    container: { paddingTop: 10, gap: 6, marginBottom: 10 },
                    label: { paddingBottom: 10, color: "#555A77" },
                    dropzone: { background: "#F1EFFB" },
                  }}
                ></MediaUploader>
                <AcceptButton
                  onClick={async () => {
                    await handleEditProductCategory(pCat._id);
                  }}
                >
                  Confirm
                </AcceptButton>
              </Modal>
            </ButtonsSection>
          );
        })}
        <Modal
          halfWidth
          isOpen={modalState?.state === "add"}
          title="Add Product Category"
          onClose={() => {
            setModalState(INITIAL_MODAL_STATE);
          }}
        >
          <LabelInputField
            label="Product Category Name"
            onChange={(e) => {
              setName(e.target.value);
            }}
            name="Name"
            style={{
              label: {
                fontSize: "14px",
                fontWeight: "500px",
                color: "#555A77",
              },
              input: {
                height: 50,
                border: "1px solid #F1EFFB",
                padding: 8,
                background: "#F1EFFB",
                borderRadius: 6,
                width: "100%",
              },
              container: {
                display: "flex",
                flexDirection: "column",
                gap: 6,
                paddingTop: 14,
              },
            }}
          />
          <MediaUploader
            label="Icon"
            onChange={(e) => {
              const file = e.target.files?.[0] || null;
              setUploadedFile(file);
            }}
            style={{
              container: { paddingTop: 10, gap: 6, marginBottom: 10 },
              label: { paddingBottom: 10, color: "#555A77" },
              dropzone: { background: "#F1EFFB" },
            }}
          ></MediaUploader>
          <AcceptButton
            onClick={() => {
              handleAddProductCategory();
            }}
          >
            Add
          </AcceptButton>
        </Modal>
      </Card>
    </div>
  );
};

export default ProductCategories;
